import React from 'react'
import { IZdsIcons, ZdsIcon } from '@zera/components'
import { Avatar } from './styles'

type UserAvatarProps = {
  iconName: IZdsIcons
}

export const UserAvatar = ({ iconName }: UserAvatarProps): JSX.Element => {
  return (
    <Avatar>
      <ZdsIcon src={iconName} />
    </Avatar>
  )
}
